import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#EEDA84",
        header: "#004438",
        secondary: "#004438",
        background: "#FFFFFF",
        black: "#000000",
        bg: "#e5e5e5",
        btncolor: "#004438",
      },
      light: {
        primary: "#EEDA84",
        header: "#004438",
        secondary: "#004438",
        background: "#FFFFFF",
        black: "#000000",
        greentext: "#004438",
        bg: "#e5e5e5",
        btncolor: "#004438",
      }
    }
  }
});
